import InlineComponent from './inlineComponent.jsx';
import NodeRQLSearch from '../../../components/rql/NodeRQLSearch.jsx';

module.exports = class OutputRenderer extends InlineComponent {
  define() {
    this.component = NodeRQLSearch;
  }
};
